// extracted by mini-css-extract-plugin
export default {"section":"PlaceOrder_section__kP4ej","heading":"PlaceOrder_heading__oEF-p","label":"PlaceOrder_label__pk434"};